module.exports = __webpack_public_path__ + "static/media/Qeqertalik Business Council QBC_2026_Logo.6d7b9090.png";